import script from "./MultiSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&setup=true&lang=ts"

import "./MultiSelect.vue?vue&type=style&index=0&id=bfdc7324&lang=scss"

const __exports__ = script;

export default __exports__